import { createTweekContext } from 'react-tweek';

import { getTweekRepository } from './utils';

export const TweekContext = createTweekContext(getTweekRepository());
export const withTweekValues = TweekContext.withTweekValues;
